import debounce from 'lodash/debounce';

class Lines {
  constructor(elements) {
    this.line1 = elements.line1;
    this.segment1 = elements.segment1;

    this.line2 = elements.line2;
    this.segment2 = elements.segment2;

    this.line3 = elements.line3;
    this.segment3 = elements.segment3;

    this.setSegmentsNextToLines(1);
    this.setSegmentsNextToLines(2);
    this.setSegmentsNextToLines(3);

    window.addEventListener('resize', debounce(() => {
      this.setSegmentsNextToLines(1);
      this.setSegmentsNextToLines(2);
      this.setSegmentsNextToLines(3);
    }), 20);
  }

  setSegmentsNextToLines = (index) => {
    const padding = 20;
    const line = this[`line${index}`];
    const segment = this[`segment${index}`];

    if (line === null || segment === null) {
      return;
    }

    const position = {
      x: line.offsetLeft + (line.offsetWidth + padding),
      y: line.offsetTop + (line.offsetHeight / 2),
    };

    const style = `left:${position.x}px;top:${position.y}px`;
    segment.setAttribute('style', style);
  }
}

const elements = {
  line1: document.querySelector('.js-line-1'),
  segment1: document.querySelector('.js-segment-1'),

  line2: document.querySelector('.js-line-2'),
  segment2: document.querySelector('.js-segment-2'),

  line3: document.querySelector('.js-line-3'),
  segment3: document.querySelector('.js-segment-3'),
};

// eslint-disable-next-line
new Lines(elements);